import React, { useContext, useEffect, useState } from "react";

// ----> IMPORTATION USETRANSLATION
import { useTranslation } from "react-i18next";


// REACT ROUTER DOM IMPORTATION
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

// ----> URLS IMPORTATION
import { urls } from "../../api-urls/api-urls";

// ----> USER CONTEXT IMPORTATION
import { UserContext } from "../../context/UserContext.jsx";

// COMPONENTS IMPORTATION
import { ToastNotification } from "../../components/toast-notification/ToastNotification.jsx";
import { MsgRedirectComp } from "../../components/service/MsgRedirectComp.jsx";
import { TourGuideComp } from "../../components/service/TourGuideComp.jsx";
import { LoginFloat } from "../../components/login-float/LoginFloat.jsx";
import { LoadingComp } from "../../components/loading-comp/LoadingComp.jsx";
import { ListPendingServ } from "../../components/service/ListPendingServ.jsx";
import { Send } from "../../components/icons/AppIcons.jsx";


import isot from "../../assets/Isotipo-2.svg"


// images
import Equipment from "../../assets/equipments.jpeg";

// custom hook importation
import { useFetchInfo } from "../../customs-hooks/service-calls/useFetchInfo.js";







export const NewCallComp = () => {


  // Use translation
  const [t] = useTranslation("global");


  // Use context
  const { user, setUserContext } = useContext(UserContext);

  // GET the useNavigate
  const navigate = useNavigate();

  // GET the useLocation
  const location = useLocation();


  // GET the useSearchParams
  const [params] = useSearchParams();

  // const ID = params.get("id_equip");
  const VAL_PARAMS = params.get("id_equip") ?? params.get("id-equip");

  // custom hook 
  const { state, customer, equipment, pendingServ, onHandleChangeSending, onCloseServPend } = useFetchInfo(location, user, VAL_PARAMS);




  // ----> STATE DEFINITION
  const [form, setForm] = useState({
    cliente: "", equipo: "", etapa: 1, problema: "", temperature: "", IdTipServicio: 1, responsableIngreso: 0,
    encargado: "", telefono: "", correo: "", idEstatus: 1, codContacto: ""
  });
  const [notification, setNotification] = useState({ show: false, msg: "", error: false, great: false, success: false, id: 0 }); // modificar esto luego


  // funcion para cambiar el valor del formulario
  const onHandleChangeVal = (newVal = "", name = "") => {
    setForm((val) => ({ ...val, [name]: newVal }));
  };

  // funcion para validar los campos
  const validateForm = (form.cliente && form.equipo && form.temperature && form.problema.length > 3);




  // funcion para crear la llamada
  const onHandleCreateCall = async (event) => {
    event.preventDefault();

    let Error = 0;
    for (const prop in form) {
      if (["cliente", "equipo", "temperature", "problema"].includes(prop)) {
        if (form[prop] === "") {
          Error += 1;
        }
      }
    }

    if (Error > 0) {
      return setNotification((val) => ({ ...val, show: true, msg: "Todas los campos son obligatorios", error: true }));
    }

    const END_POINT = `${urls.serviceEquipments}`;

    const TOKEN = localStorage.getItem("token");

    try {
      onHandleChangeSending(true);

      const response = await fetch(END_POINT, {
        method: "POST",
        headers: {
          "Authorization": TOKEN,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(form)
      });

      const data = await response.json();

      if (response.status === 201) {
        setNotification((val) => ({ ...val, success: true, id: data?.id }));
        setForm((val) => ({ ...val, problema: "", temperature: "" }));
      } else if (response.status === 500) {
        setNotification((val) => ({ ...val, show: true, msg: data?.msg, error: true }));
      }

      onHandleChangeSending(false);

    } catch (error) {
      console.log(error);
    }
  };



  // useEffect para limpiar las notificaciones
  useEffect(() => {

    const timer = setTimeout(() => {
      setNotification((val) => ({ ...val, show: false, msg: "", error: false, great: false, success: false }));
    }, 5000);

    return () => {
      clearTimeout(timer);
    };

  }, [notification.show]);


  // useEffect para cargar los datos del usuario en el form
  useEffect(() => {
    setForm((val) => ({ ...val, cliente: user?.CodCliente, encargado: user?.Nombre, telefono: user?.Telefono, correo: user?.Correo, codContacto: user?.CodContacto }));
  }, [user]);



  useEffect(() => {

    setForm((val) => ({ ...val, equipo: state.equip }));

  }, [state.equip]);




  return (
    <>
      {
        state.isLoading && (<LoadingComp />)
      }
      {
        state.modalLogin && (
          <LoginFloat setUserC={setUserContext} />
        )
      }
      {
        state.modalPend && (<ListPendingServ list={pendingServ} onClose={onCloseServPend} />)
      }
      {/* {
        // modal para el tour guide
        state.modalTourG && (
          <TourGuideComp />
        )
      } */}
      {
        // Msg redirect comp
        notification.success && (
          <MsgRedirectComp idCall={notification.id} />
        )
      }
      {
        // Toast notification
        notification.show && (<ToastNotification success={notification.great} error={notification.error} msg={notification.msg} />)
      }
      {/* {
        state.dataVisible && (
          <NavBarComp />
        )
      } */}
      {
        state.dataVisible && (
          <div className="container row-flex justify-center">

            <div className="card-report-case">
              <div className="row-flex justify-center">
                <img className="header-img-report" src={Equipment} alt="equipment" />
              </div>
              <h4 className="txt-center">{t("NewCallComp.report_falla")}</h4>

              <form onSubmit={onHandleCreateCall}>
                <div className="row-flex m-y-small">
                  <div className="col-5">
                    <strong>{t("NewCallComp.step")}</strong>
                  </div>
                  <div className="col-65 flex-grow-1">
                    <span className="txt-muted bg-green-b">{t("NewCallComp.firstStep")}</span>
                  </div>
                </div>
                <div className="row-flex m-y-small">
                  <div className="col-5 row-flex gap-small col-70-mob">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="var(--first-color)" className="bi bi-person-plus-fill" viewBox="0 0 16 16">
                      <path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                      <path fillRule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5" />
                    </svg>
                    <strong>{t("NewCallComp.customer")}</strong>
                  </div>
                  <div className="col-65 flex-grow-1">
                    <select
                      name="custo-selec"
                      value={form.cliente}
                      onChange={({ target }) => onHandleChangeVal(target.value, "cliente")}
                    >
                      <option value=""></option>
                      {
                        customer && customer.map((cust) => (
                          <option key={cust.CodCliente} value={cust.CodCliente}>{cust.Nombre}</option>
                        ))
                      }
                    </select>
                  </div>
                </div>

                <div className="row-flex">
                  <div className="col-5 row-flex gap-small col-70-mob">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="var(--first-color)" className="bi bi-pc-display" viewBox="0 0 16 16">
                      <path d="M8 1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1zm1 13.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0m2 0a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0M9.5 1a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM9 3.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5M1.5 2A1.5 1.5 0 0 0 0 3.5v7A1.5 1.5 0 0 0 1.5 12H6v2h-.5a.5.5 0 0 0 0 1H7v-4H1.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5H7V2z" />
                    </svg>
                    <strong>{t("NewCallComp.equipment")}</strong>
                  </div>
                  <div className="col-65 flex-grow-1">
                    <select
                      style={{ color: VAL_PARAMS !== "" ? "" : "#ff0000" }}
                      name="equip-selec"
                      value={form.equipo}
                      disabled>
                      <option value="">{t("NewCallComp.escanear_qr")}</option>
                      {
                        equipment && equipment.map((equi) => (
                          <option key={equi.CodEquipo} value={equi.CodEquipo}>{equi.Equipo}</option>
                        ))
                      }
                    </select>
                  </div>
                </div>

                <div className="row-flex m-y-small">
                  <div className="col-5 row-flex gap-small col-70-mob">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="var(--first-color)" className="bi bi-clipboard2-pulse-fill" viewBox="0 0 16 16">
                      <path d="M10 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5.5.5 0 0 0-.5.5V2a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 11 2v-.5a.5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5" />
                      <path d="M4.085 1H3.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1h-.585q.084.236.085.5V2a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 2v-.5q.001-.264.085-.5M9.98 5.356 11.372 10h.128a.5.5 0 0 1 0 1H11a.5.5 0 0 1-.479-.356l-.94-3.135-1.092 5.096a.5.5 0 0 1-.968.039L6.383 8.85l-.936 1.873A.5.5 0 0 1 5 11h-.5a.5.5 0 0 1 0-1h.191l1.362-2.724a.5.5 0 0 1 .926.08l.94 3.135 1.092-5.096a.5.5 0 0 1 .968-.039Z" />
                    </svg>
                    <strong>{t("NewCallComp.temperature")}</strong>
                  </div>
                  <div className="col-65 flex-grow-1">
                    <select
                      name="temper-selec"
                      value={form.temperature}
                      onChange={({ target }) => onHandleChangeVal(target.value, "temperature")}>
                      <option>{t("NewCallComp.select_temp")}</option>
                      <option value="0">{t("NewCallComp.greenMeaning")}</option>
                      <option value="1">{t("NewCallComp.yellowMeaning")}</option>
                      <option value="4">{t("NewCallComp.redMeaning")}</option>
                    </select>
                  </div>
                </div>

                <div className="row-flex">
                  <div className="col-5 row-flex gap-small col-70-mob">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="var(--first-color)" className="bi bi-keyboard-fill" viewBox="0 0 16 16">
                      <path d="M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm13 .25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25M2.25 8a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 3 8.75v-.5A.25.25 0 0 0 2.75 8zM4 8.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 5 8.75v-.5A.25.25 0 0 0 4.75 8h-.5a.25.25 0 0 0-.25.25M6.25 8a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 7 8.75v-.5A.25.25 0 0 0 6.75 8zM8 8.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 9 8.75v-.5A.25.25 0 0 0 8.75 8h-.5a.25.25 0 0 0-.25.25M13.25 8a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zm0 2a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zm-3-2a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h1.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zm.75 2.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25M11.25 6a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zM9 6.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5A.25.25 0 0 0 9.75 6h-.5a.25.25 0 0 0-.25.25M7.25 6a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 8 6.75v-.5A.25.25 0 0 0 7.75 6zM5 6.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 6 6.75v-.5A.25.25 0 0 0 5.75 6h-.5a.25.25 0 0 0-.25.25M2.25 6a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h1.5A.25.25 0 0 0 4 6.75v-.5A.25.25 0 0 0 3.75 6zM2 10.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25M4.25 10a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h5.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25z" />
                    </svg>
                    <strong>{t("NewCallComp.equipmentFailureDescrip")}</strong>
                  </div>
                  <div className="col-65 flex-grow-1">
                    <textarea
                      className="textarea-description"
                      name="fail-descrip"
                      value={form.problema}
                      onChange={({ target }) => onHandleChangeVal(target.value, "problema")} />
                  </div>
                </div>

                <div className="row-flex m-y-medium j-c-space-a">
                  <button type={state.sending || !validateForm ? "button" : "submit"} className={`btn-primary btn-flex ${validateForm ? "" : "disabled"}`}>
                    <Send />
                    {state.sending ? t("NewCallComp.enviando") : t("NewCallComp.enviar")}
                  </button>
                  <button type="reset" className="btn-secondary" onClick={() => navigate(-1, { replace: true })}>
                    {t("NewCallComp.atras")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )
      }


    </>
  );
};